/**
 * AvatarCard 스타일
 * @description 시안 `avatar-card`(`3041:2434`). 얼굴 하나에 이름과 이유. 가운데 정렬이고
 *   글자는 두 줄까지 늘어난다 — 그래서 카드 높이가 항목마다 달라지는데, 늘어놓는 쪽이
 *   위를 맞춘다.
 */
import { cva } from "class-variance-authority";

export const avatarCardStyles = {
  root: cva("flex w-full flex-col items-center gap-[var(--fw-space-gap-sm)]", {
    variants: {
      interactive: {
        true: "group cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--fw-color-border-focused)] [&>:first-child]:transition-transform [&>:first-child]:duration-300 motion-safe:hover:[&>:first-child]:-translate-y-[var(--fw-space-gap-xs)] motion-safe:hover:[&>:first-child]:scale-105",
        false: "",
      },
    },
    defaultVariants: { interactive: false },
  }),
  texts: "flex w-full flex-col items-center gap-[var(--fw-space-gap-xs)]",
  name: "fw-l2-tight w-full truncate text-center text-[var(--fw-color-content-neutral-secondary)]",
  caption:
    "fw-caption line-clamp-2 text-center text-[var(--fw-color-content-neutral-tertiary)]",
};
